import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { isLeafletMapUsable, stopLeafletMap } from '../util/BaseMap.utils';

export default function ResetZoomMapEvent({
  setInitPos,
  setInitZoom,
  triggerReset,
  initPos,
  initZoom,
}) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    if (!isLeafletMapUsable(map)) return;

    const hasInitZoom = initZoom !== undefined && initZoom !== null;

    let center, zoom;

    try {
      center = map.getCenter();
      zoom = map.getZoom();
    } catch (error) {
      console.error('Error getting map center or zoom:', error);
      return;
    }

    if (
      (!initPos || !hasInitZoom) &&
      typeof setInitPos === 'function' &&
      typeof setInitZoom === 'function'
    ) {
      if (center && zoom !== undefined) {
        setInitPos(center);
        setInitZoom(zoom);
      }
    }

    if (triggerReset && initPos && hasInitZoom) {
      stopLeafletMap(map); // stop any ongoing map animations before resetting view
      map.setView(initPos, initZoom);
    }
  }, [triggerReset, initPos, initZoom, map, setInitPos, setInitZoom]);

  return null;
}
